import { PERMISSION_GROUP_TYPES } from "../utils/PermissionUtils";

const cretePermission = (name, group, descTr, descEn, descRu, descDe, descFr, descEs, descSa, descIt) => ({
    en: {
        name,
        entity: group.en,
        description: descEn,
    },
    tr: {
        name,
        entity: group.tr,
        description: descTr,
    },
    ru: {
        name,
        entity: group.ru,
        description: descRu,
    },
    de: {
        name,
        entity: group.de,
        description: descDe,
    },
    fr: {
        name,
        entity: group.fr,
        description: descFr,
    },
    es: {
        name,
        entity: group.es,
        description: descEs,
    },
    ar: {
        name,
        entity: group.ar,
        description: descSa,
    },
    it: {
        name,
        entity: group.it,
        description: descIt,
    },
});
export const PERMISSION_TYPES = {
    "user.create": cretePermission(
        "user.create",
        PERMISSION_GROUP_TYPES.USERS,
        "Kullanıcı Ekleme",
        "Add User",
        "Добавление пользователя",
        "Benutzer hinzufügen",
        "Ajouter un utilisateur",
        "Agregar usuario",
        "إضافة مستخدم",
        "Aggiungi utente"
    ),
    "user.get": cretePermission(
        "user.get",
        PERMISSION_GROUP_TYPES.USERS,
        "Kullanıcı Görüntüleme",
        "View User",
        "Просмотр пользователя",
        "Benutzeransichten",
        "Vues utilisateur",
        "Vistas de usuario",
        "مشاهدات المستخدم",
        "Visualizzazioni utente"
    ),
    "user.update": cretePermission(
        "user.update",
        PERMISSION_GROUP_TYPES.USERS,
        "Kullanıcı Güncelleme",
        "Update User",
        "Обновление пользователя",
        "Benutzeraktualisierung",
        "Mise à jour de l'utilisateur",
        "Actualización de usuario",
        "تحديث المستخدم",
        "Aggiornamento utente"
    ),
    "user.delete": cretePermission(
        "user.delete",
        PERMISSION_GROUP_TYPES.USERS,
        "Kullanıcı Silme",
        "Delete User",
        "Удаление пользователя",
        "User Löschung",
        "Suppression d'utilisateur",
        "Eliminación de usuario",
        "حذف المستخدم",
        "Elimina utente"
    ),

    "visitor.block": cretePermission(
        "visitor.block",
        PERMISSION_GROUP_TYPES.VISITOR,
        "Ziyaretçi Engelleme",
        "Blocking Visitor",
        "Блокировка посетителей",
        "Benutzer Loschung",
        "Blocage des visiteurs",
        "Bloqueo de visitantes",
        "منع الزوار",
        "Blocco dei visitatori"
    ),
    "visitor.unblock": cretePermission(
        "visitor.unblock",
        PERMISSION_GROUP_TYPES.VISITOR,
        "Ziyaretçi Engel Kaldırma",
        "Unblocking Visitor",
        "Разблокировать посетителя",
        "Besucher-Entsperrung",
        "Déblocage des visiteurs",
        "Desbloqueo de visitantes",
        "إلغاء حظر الزائر",
        "Sblocco del visitatore"
    ),

    "visitor.list.view": cretePermission(
        "visitor.list.view",
        PERMISSION_GROUP_TYPES.VISITOR,
        "Ziyaretçiler Görüntüleme İzni",
        "View Visitor List",
        "Отображение сведений о посетителях",
        "Besucher-Detailansicht",
        "Vue détaillée du visiteur",
        "Vista detallada del visitante",
        "عرض تفاصيل الزائر"
    ),
    "visitor.delete": cretePermission(
        "visitor.delete",
        PERMISSION_GROUP_TYPES.VISITOR,
        "Ziyaretçi Silme İzni",
        "View Visitor List",
        "Отображение сведений о посетителях",
        "Besucher-Detailansicht",
        "Vue détaillée du visiteur",
        "Vista detallada del visitante",
        "عرض تفاصيل الزائر"
    ),
    "visitor.excel": cretePermission(
        "visitor.excel",
        PERMISSION_GROUP_TYPES.VISITOR,
        "Ziyaretçi Excel İzni",
        "View Visitor List",
        "Отображение сведений о посетителях",
        "Besucher-Detailansicht",
        "Vue détaillée du visiteur",
        "Vista detallada del visitante",
        "عرض تفاصيل الزائر"
    ),
    "visitor.update": cretePermission(
        "visitor.update",
        PERMISSION_GROUP_TYPES.VISITOR,
        "Ziyaretçi Güncelleme İzni",
        "View Visitor List",
        "Отображение сведений о посетителях",
        "Besucher-Detailansicht",
        "Vue détaillée du visiteur",
        "Vista detallada del visitante",
        "عرض تفاصيل الزائر"
    ),
    "bannedVisitor.view": cretePermission(
        "bannedVisitor.view",
        PERMISSION_GROUP_TYPES.VISITOR,
        "Yasaklı Ziyaretçiler Görüntüleme",
        "View Banned Visitor",
        "Просмотр запрещенных посетителей",
        "Gesperrte Besucher",
        "Affichage des visiteurs interdits",
        "Visualización de visitantes prohibidos",
        "الزوار المحظورين المشاهدة",
        "Visualizza visitatori vietati"
    ),

    "bannedWord.create": cretePermission(
        "bannedWord.create",
        PERMISSION_GROUP_TYPES.BANNED_WORD,
        "Yasaklı Kelime Ekleme",
        "Add Banned Word",
        "Добавление запрещенных слов",
        "Ein verbotenes Wort hinzufügen",
        "Ajouter un mot interdit",
        "Agregar una palabra prohibida",
        "إضافة كلمة محظورة",
        "Aggiungi parola vietata"
    ),
    "bannedWord.get": cretePermission(
        "bannedWord.get",
        PERMISSION_GROUP_TYPES.BANNED_WORD,
        "Yasaklı Kelime Görüntüleme",
        "View Banned Word",
        "Отображение запрещенных слов",
        "Verbotene Wortanzeige",
        "Affichage des mots interdits",
        "Visualización de palabras prohibidas",
        "عرض الكلمات المحظورة",
        "Visualizza parola vietata"
    ),
    "bannedWord.update": cretePermission(
        "bannedWord.update",
        PERMISSION_GROUP_TYPES.BANNED_WORD,
        "Yasaklı Kelime Güncelleme",
        "Update Banned Word",
        "Обновление запрещённых слов",
        "Verbotenes Word-Update",
        "Mise à jour des mots interdits",
        "Actualización de palabra prohibida",
        "تحديث Word المحظور",
        "Aggiorna parola vietata"
    ),
    "bannedWord.delete": cretePermission(
        "bannedWord.delete",
        PERMISSION_GROUP_TYPES.BANNED_WORD,
        "Yasaklı Kelime Silme",
        "Delete Banned Word",
        "Удалить запрещённое слово",
        "Verbotene Wortlöschung",
        "Suppression de mots interdits",
        "Eliminación de palabras prohibidas",
        "حذف كلمة ممنوع",
        "Elimina parola vietata"
    ),

    "chat.get": cretePermission(
        "chat.get",
        PERMISSION_GROUP_TYPES.CHAT,
        "Konuşma Görüntüleme",
        "View Chat",
        "Просмотр чата",
        "Sprachansicht",
        "Vue de la parole",
        "Vista de voz",
        "عرض الدردشة",
        "Visualizza chat"
    ),
    "chat.update": cretePermission(
        "chat.update",
        PERMISSION_GROUP_TYPES.CHAT,
        "Konuşma Güncelleme",
        "Update Chat",
        " Обновление чата",
        "Sprachaktualisierung",
        "Mise à jour de la parole",
        "Actualización de voz",
        "تحديث الكلام",
        "Aggiorna chat"
    ),
    "archives.get": cretePermission(
        "archives.get",
        PERMISSION_GROUP_TYPES.CHAT,
        "Arşiv Listeleme",
        "View Archive",
        " Просмотр архива",
        "Archivansicht",
        "Vue d'archive",
        "Vista de archivo",
        "عرض الأرشيف",
        "Visualizza archivio"
    ),
    "role.create": cretePermission(
        "role.create",
        PERMISSION_GROUP_TYPES.ROLE,
        "Rol Ekleme",
        "Add Role",
        " Добавление должности",
        "Rolle hinzufügen",
        "Ajouter un rôle",
        "Agregar rol",
        "إضافة دور",
        "Aggiungi ruolo"
    ),
    "role.get": cretePermission(
        "role.get",
        PERMISSION_GROUP_TYPES.ROLE,
        "Rol Görüntüleme",
        "View Role",
        " Просмотр должности",
        "Rolle anzeigen",
        "Afficher le rôle",
        "Ver rol",
        "عرض الدور",
        "Visualizza ruolo"
    ),
    "role.update": cretePermission(
        "role.update",
        PERMISSION_GROUP_TYPES.ROLE,
        "Rol Güncelleme",
        "Update Role",
        " Обновление должности",
        "Sprachaktualisierung",
        "Mise à jour du rôle",
        "Actualización de roles",
        "تحديث الدور",
        "Aggiorna ruolo"
    ),
    "role.delete": cretePermission(
        "role.delete",
        PERMISSION_GROUP_TYPES.ROLE,
        "Rol Silme",
        "Delete Role",
        " Удаление должности",
        "Rolle löschen",
        "Supprimer le rôle",
        "Eliminar rol",
        "حذف الدور",
        "Elimina ruolo"
    ),
    "topic.create": cretePermission(
        "topic.create",
        PERMISSION_GROUP_TYPES.TOPIC,
        "Departman Ekleme",
        "Add Subject",
        " Добавление темы",
        "Thema hinzufügen",
        "Ajouter un sujet",
        "Agregar tema",
        "إضافة موضوع",
        "Aggiungi argomento"
    ),

    "topic.update": cretePermission(
        "topic.update",
        PERMISSION_GROUP_TYPES.TOPIC,
        "Departman Güncelleme",
        "Update Subject",
        " Обновить тему",
        "Themenaktualisierung",
        "Mise à jour des mots interdits",
        "Actualización de tema",
        "تحديث الموضوع",
        "Aggiorna argomento"
    ),
    "topic.delete": cretePermission(
        "topic.delete",
        PERMISSION_GROUP_TYPES.TOPIC,
        "Departman Silme",
        "Delete Subject",
        " Удалить тему",
        "Thema löschen",
        "Supprimer le sujet",
        "Eliminar tema",
        "حذف الموضوع",
        "Elimina argomento"
    ),
    "prepared.create": cretePermission(
        "prepared.create",
        PERMISSION_GROUP_TYPES.CONTENT,
        "Hazır İçerik Ekleme",
        "Add Prepared Content",
        " Добавить готовый контент",
        "Bestandsinhalte hinzufügen",
        "Ajout de contenu de stock",
        "Adición de contenido de stock",
        "إضافة محتوى المخزون",
        "Aggiungi contenuto preparato"
    ),
    "prepared.get": cretePermission(
        "prepared.get",
        PERMISSION_GROUP_TYPES.CONTENT,
        "Hazır İçerik Görüntüleme",
        "View Prepared Content",
        " Посмотреть готовый контент",
        "Bestandsanzeige",
        "Affichage du contenu du stock",
        "Visualización de contenido de existencias",
        "عرض محتوى المخزون",
        "Visualizza contenuto preparato"
    ),
    "prepared.update": cretePermission(
        "prepared.update",
        PERMISSION_GROUP_TYPES.CONTENT,
        "Hazır İçerik Güncelleme",
        "Update Prepared Content",
        " Обновить подготовленный контент",
        "Stock-Inhaltsaktualisierung",
        "Mise à jour du contenu du stock",
        "Actualización de contenido de existencias",
        "تحديث محتوى المخزون",
        "Aggiorna contenuto preparato"
    ),
    "prepared.delete": cretePermission(
        "prepared.delete",
        PERMISSION_GROUP_TYPES.CONTENT,
        "Hazır İçerik Silme",
        "Delete Prepared Content",
        " Удалить подготовленный контент",
        "Sofortige Inhaltslöschung",
        "Suppression instantanée du contenu",
        "Eliminación instantánea de contenido",
        "حذف فوري للمحتوى",
        "Elimina contenuto preparato"
    ),
    "welcome.create": cretePermission(
        "welcome.create",
        PERMISSION_GROUP_TYPES.WELCOME,
        "Karşılama Mesajı Ekleme",
        "Add Welcome Message",
        " Добавление приветственного сообщения",
        "Hinzufügen einer Willkommensnachricht",
        "Ajout d'un message de bienvenue",
        "Agregar un mensaje de bienvenida",
        "إضافة رسالة ترحيب",
        "Aggiungi messaggio di benvenuto"
    ),
    "welcome.get": cretePermission(
        "welcome.get",
        PERMISSION_GROUP_TYPES.WELCOME,
        "Karşılama Mesajı Görüntüleme",
        "View Welcome Message",
        " Просмотр приветственного сообщения",
        "Anzeigen einer Willkommensnachricht",
        "Affichage d'un message de bienvenue",
        "Mostrar un mensaje de bienvenida",
        "عرض رسالة ترحيب",
        "Visualizza messaggio di benvenuto"
    ),
    "welcome.update": cretePermission(
        "welcome.update",
        PERMISSION_GROUP_TYPES.WELCOME,
        "Karşılama Mesajı Güncelleme",
        "Update Welcome Message",
        " Обновление приветственного сообщения",
        "Aktualisierung der Begrüßungsnachricht",
        "Mise à jour du message de bienvenue",
        "Actualización del mensaje de bienvenida",
        "تحديث رسالة الترحيب",
        "Aggiorna messaggio di benvenuto"
    ),
    "welcome.delete": cretePermission(
        "welcome.delete",
        PERMISSION_GROUP_TYPES.WELCOME,
        "Karşılama Mesajı Silme",
        "Delete Welcome Message",
        " Удаление приветственного сообщения",
        "Löschen einer Begrüßungsnachricht",
        "Supprimer un message de bienvenue",
        "Eliminación de un mensaje de bienvenida",
        "حذف رسالة ترحيب",
        "Elimina messaggio di benvenuto"
    ),
    "setting.create": cretePermission(
        "setting.create",
        PERMISSION_GROUP_TYPES.SETTING,
        "Ayar Ekleme",
        "Add Setting",
        " Добавление настроек",
        "Einstellungen hinzufügen",
        "Ajout de paramètres",
        "Agregar configuraciones",
        "إضافة الإعدادات",
        "Aggiungi impostazione"
    ),
    "setting.get": cretePermission(
        "setting.get",
        PERMISSION_GROUP_TYPES.SETTING,
        "Ayar Görüntüleme",
        "View Setting",
        " Просмотр настроек",
        "Anzeige einstellen",
        "Réglage de l'affichage",
        "Pantalla de configuración",
        "عرض الإعداد",
        "Visualizza impostazione"
    ),
    "setting.update": cretePermission(
        "setting.update",
        PERMISSION_GROUP_TYPES.SETTING,
        "Ayar Güncelleme",
        "Update Setting",
        " Обновить настройки",
        "Einstellungsaktualisierung",
        "Mise à jour des paramètres",
        "Configuración de actualización",
        "تحديث الإعداد",
        "Aggiorna impostazione"
    ),
    "setting.delete": cretePermission(
        "setting.delete",
        PERMISSION_GROUP_TYPES.SETTING,
        "Ayar Silme",
        "Delete Setting",
        " Удалить настройку",
        "Einstellung löschen",
        "Paramètre Supprimer",
        "Configuración Eliminar",
        "حذف الإعداد",
        "Elimina impostazione"
    ),
    "report.create": cretePermission(
        "report.create",
        PERMISSION_GROUP_TYPES.REPORT,
        "Rapor Ekleme",
        "Add Report",
        " Добавить отчет",
        "Bericht hinzufügen",
        "Ajouter un rapport",
        "Agregar informe",
        "إضافة تقرير",
        "Aggiungi rapporto"
    ),
    "report.get": cretePermission(
        "report.get",
        PERMISSION_GROUP_TYPES.REPORT,
        "Rapor Görüntüleme",
        "View Report",
        " Посмотреть отчет",
        "Anzeigen von Berichten",
        "Paramètre Supprimer",
        "Visualización de informes",
        "عرض التقرير",
        "Visualizza rapporto"
    ),
    "report.update": cretePermission(
        "report.update",
        PERMISSION_GROUP_TYPES.REPORT,
        "Rapor Güncelleme",
        "Update Report",
        " Обновить отчет",
        "Berichtsaktualisierung",
        "Mise à jour du rapport",
        "Actualización del informe",
        "تقرير التحديث",
        "Aggiorna rapporto"
    ),
    "report.delete": cretePermission(
        "report.delete",
        PERMISSION_GROUP_TYPES.REPORT,
        "Rapor Silme",
        "Delete Report",
        " Удалить отчет",
        "Löschen eines Berichts",
        "Suppression d'un rapport",
        "Eliminación de un informe",
        "حذف تقرير",
        "Elimina rapporto"
    ),
    "offlineSupportRequest.get": cretePermission(
        "offlineSupportRequest.get",
        PERMISSION_GROUP_TYPES.OSR,
        "Mesajları Listeleme",
        "List Messages",
        " Список сообщений",
        "Nachrichten auflisten",
        "Liste des messages",
        "Listado de mensajes",
        "سرد الرسائل",
        "Elenco dei messaggi"
    ),
    "offlineSupportRequest.update": cretePermission(
        "offlineSupportRequest.update",
        PERMISSION_GROUP_TYPES.OSR,
        "Cevap Yazma",
        "Write Response",
        "Написать Ответ",
        "Antwort",
        "Répondre",
        "Responder",
        "رد",
        "Rispondi"
    ),
    "offlineSupportRequest.delete": cretePermission(
        "offlineSupportRequest.delete",
        PERMISSION_GROUP_TYPES.OSR,
        "Mesaj Silme",
        "Delete Message",
        " Удалить сообщение",
        "Nachricht löschen",
        "Suppression de messages",
        "Eliminación de mensajes",
        "حذف الرسائل",
        "Elimina messaggio"
    ),
    "offlineSupportRequest.create": cretePermission(
        "offlineSupportRequest.create",
        PERMISSION_GROUP_TYPES.OSR,
        "Çevrimdışı Destek(Ticket) Talebi Oluşturma İzni",
        "Creating Offline Support Request Permission ",
        "Создание разрешения на запрос поддержки в автономном режиме",
        "Berechtigung zum Erstellen eines Offline-Supportfalls",
        "Autorisation de créer un dossier de support hors ligne",
        "Permiso para crear un caso de soporte sin conexión",
        "إذن لإنشاء حالة دعم دون اتصال",
        "Permesso per creare una richiesta di supporto offline"
    ),
    "catalog.get": cretePermission(
        "catalog.get",
        PERMISSION_GROUP_TYPES.CATALOG,
        "Catalog Görüntülüme İzni",
        "View Catalog",
        " Просмотр каталога",
        "Berechtigung zur Katalogansicht",
        "Autorisation d'affichage du catalogue",
        "Permiso de vista de catálogo",
        "إذن عرض الكتالوج",
        "Permesso di visualizzazione del catalogo"
    ),
    "catalog.update": cretePermission(
        "catalog.update",
        PERMISSION_GROUP_TYPES.CATALOG,
        "Catalog Güncelleme İzni",
        "Update Catalog",
        " Обновление каталога",
        "Berechtigung zur Katalogaktualisierung",
        "Autorisation de mise à jour du catalogue",
        "Permiso de actualización de catálogo",
        "إذن تحديث الكتالوج",
        "Permesso di aggiornamento del catalogo"
    ),
    "catalog.create": cretePermission(
        "catalog.create",
        PERMISSION_GROUP_TYPES.CATALOG,
        "Catalog Oluşturma İzni",
        "Add Catalog",
        "Добавить каталог",
        "Berechtigung zum Erstellen eines Katalogs",
        "Berechtigung zum Erstellen eines Catalogues",
        "Permiso para crear catálogo",
        "إذن لإنشاء كتالوج",
        "Permesso per aggiungere catalogo"
    ),
    "catalog.delete": cretePermission(
        "catalog.delete",
        PERMISSION_GROUP_TYPES.CATALOG,
        "Catalog Silme İzni",
        "Delete Catalog",
        " Удалить каталог",
        "Berechtigung zum Löschen des Katalogs",
        "Autorisation de suppression de catalogue",
        "Permiso de eliminación de catálogo",
        "إذن حذف الكتالوج",
        "Permesso di eliminazione del catalogo"
    ),
    "chatbot.view": cretePermission(
        "chatbot.view",
        PERMISSION_GROUP_TYPES.CHATBOT,
        "Chatbot  Görüntüleme İzni",
        "Chatbot  View Permission",
        "Чатбот Просмотр Разрешения",
        "Chatbot Ansichtsberechtigung",
        "Autorisation d'affichage du chatbot",
        "Permiso de vista de chatbot",
        "إذن عرض الدردشة",
        "Permesso di visualizzazione di chatbot"
    ),
    "chatbot.stories.view": cretePermission(
        "chatbot.stories.view",
        PERMISSION_GROUP_TYPES.CHATBOT,
        "Chatbot Hikayeler Görüntüleme İzni",
        "Chatbot Stories View Permission",
        "Чатбот Истории Просмотр Разрешения",
        "Chatbot Geschichten Ansichtsberechtigung",
        "Autorisation d'affichage des histoires de chatbot",
        "Permiso de vista de historias de chatbot",
        "إذن عرض قصص الدردشة",
        "Permesso di visualizzazione delle storie di chatbot"
    ),
    "chatbot.stories.create": cretePermission(
        "chatbot.stories.create",
        PERMISSION_GROUP_TYPES.CHATBOT,
        "Chatbot Hikayeler Oluşturma İzni",
        "Permission to Create Chatbot Stories",
        "Разрешение на создание историй чатбота",
        "Berechtigung zum Erstellen von Chatbot-Geschichten",
        "Autorisation de créer des histoires de chatbot",
        "Permiso para crear historias de chatbot",
        "إذن إنشاء قصص الدردشة",
        "Permesso di creare storie di chatbot"
    ),
    "chatbot.stories.update": cretePermission(
        "chatbot.stories.update",
        PERMISSION_GROUP_TYPES.CHATBOT,
        "Chatbot Hikayeler Güncelleme İzni",
        "Chatbot Stories Update Permission",
        "Чатбот Истории Обновить Разрешение",
        "Chatbot-Geschichten-Update-Berechtigung",
        "Autorisation de mise à jour des histoires de chatbot",
        "Permiso de actualización de historias de chatbot",
        "إذن تحديث قصص الدردشة",
        "Permesso di aggiornamento delle storie di chatbot"
    ),
    "chatbot.stories.delete": cretePermission(
        "chatbot.stories.delete",
        PERMISSION_GROUP_TYPES.CHATBOT,
        "Chatbot Hikayeler Silme İzni",
        "Chatbot Stories Delete Permission",
        "Чатбот Истории Удалить Разрешение",
        "Chatbot-Geschichten-Löschen-Berechtigung",
        "Autorisation de suppression des histoires de chatbot",
        "Permiso de eliminación de historias de chatbot",
        "إذن حذف قصص الدردشة",
        "Permesso di eliminazione delle storie di chatbot"
    ),
    "chatbot.templates.view": cretePermission(
        "chatbot.templates.view",
        PERMISSION_GROUP_TYPES.CHATBOT,
        "Chatbot Şablonlar Görüntüleme İzni",
        "Chatbot Templates View Permission",
        "Чатбот Шаблоны Просмотр Разрешения",
        "Chatbot-Vorlagen-Ansichtsberechtigung",
        "Autorisation d'affichage des modèles de chatbot",
        "Permiso de vista de plantillas de chatbot",
        "إذن عرض قوالب الدردشة",
        "Permesso di visualizzazione dei modelli di chatbot"
    ),
    "chatbot.aitemplates.view": cretePermission(
        "chatbot.aitemplates.view",
        PERMISSION_GROUP_TYPES.CHATBOT,
        "Chatbot AI Şablonlar Görüntüleme İzni",
        "Chatbot AI Templates View Permission",
        "Чатбот Шаблоны ИИ Просмотр Разрешения",
        "Chatbot AI-Vorlagen-Ansichtsberechtigung",
        "Autorisation d'affichage des modèles d'IA de chatbot",
        "Permiso de vista de plantillas de IA de chatbot",
        "إذن عرض قوالب الذكاء الاصطناعي للدردشة",
        "Permesso di visualizzazione dei modelli di intelligenza artificiale di chatbot"
    ),
    "chatbot.integrations.view": cretePermission(
        "chatbot.integrations.view",
        PERMISSION_GROUP_TYPES.CHATBOT,
        "Chatbot Entegrasyonlar Görüntüleme İzni",
        "Chatbot Integrations View Permission",
        "Чатбот Интеграции Просмотр Разрешения",
        "Chatbot-Integrationen-Ansichtsberechtigung",
        "Autorisation d'affichage des intégrations de chatbot",
        "Permiso de vista de integraciones de chatbot",
        "إذن عرض تكاملات الدردشة",
        "Permesso di visualizzazione delle integrazioni di chatbot"
    ),
    "chatbot.archive.view": cretePermission(
        "chatbot.archive.view",
        PERMISSION_GROUP_TYPES.CHATBOT,
        "Chatbot Arşiv Görüntüleme İzni",
        "Chatbot Archive View Permission",
        "Чатбот Архив Просмотр Разрешения",
        "Chatbot-Archiv-Ansichtsberechtigung",
        "Autorisation d'affichage des archives de chatbot",
        "Permiso de vista de archivo de chatbot",
        "إذن عرض أرشيف الدردشة",
        "Permesso di visualizzazione dell'archivio di chatbot"
    ),
    "chatbot.entities.view": cretePermission(
        "chatbot.entities.view",
        PERMISSION_GROUP_TYPES.CHATBOT,
        "Chatbot Varlıklar Görüntüleme İzni",
        "Chatbot Entities View Permission",
        "Чатбот Сущности Просмотр Разрешения",
        "Chatbot-Entitäten-Ansichtsberechtigung",
        "Autorisation d'affichage des entités de chatbot",
        "Permiso de vista de entidades de chatbot",
        "إذن عرض كيانات الدردشة",
        "Permesso di visualizzazione delle entità di chatbot"
    ),
    "chatbot.entities.create": cretePermission(
        "chatbot.entities.create",
        PERMISSION_GROUP_TYPES.CHATBOT,
        "Chatbot Varlıklar Ekleme İzni",
        "Chatbot Entities Create Permission",
        "Чатбот Сущности Создать Разрешение",
        "Chatbot-Entitäten-Erstellungsberechtigung",
        "Autorisation de création d'entités de chatbot",
        "Permiso de creación de entidades de chatbot",
        "إذن إنشاء كيانات الدردشة",
        "Permesso di creazione di entità di chatbot"
    ),
    "chatbot.entities.update": cretePermission(
        "chatbot.entities.update",
        PERMISSION_GROUP_TYPES.CHATBOT,
        "Chatbot Varlıklar Güncelleme İzni",
        "Chatbot Entities Update Permission",
        "Чатбот Сущности Обновить Разрешение",
        "Chatbot-Entitäten-Update-Berechtigung",
        "Autorisation de mise à jour des entités de chatbot",
        "Permiso de actualización de entidades de chatbot",
        "إذن تحديث كيانات الدردشة",
        "Permesso di aggiornamento delle entità di chatbot"
    ),
    "chatbot.entities.delete": cretePermission(
        "chatbot.entities.delete",
        PERMISSION_GROUP_TYPES.CHATBOT,
        "Chatbot Varlıklar Silme İzni",
        "Chatbot Entities Delete Permission",
        "Чатбот Сущности Удалить Разрешение",
        "Chatbot-Entitäten-Löschen-Berechtigung",
        "Autorisation de suppression des entités de chatbot",
        "Permiso de eliminación de entidades de chatbot",
        "إذن حذف كيانات الدردشة",
        "Permesso di eliminazione delle entità di chatbot"
    ),
    "chatbot.reports.view": cretePermission(
        "chatbot.reports.view",
        PERMISSION_GROUP_TYPES.CHATBOT,
        "Chatbot Raporlar Görüntüleme İzni",
        "Chatbot Reports View Permission",
        "Чатбот Отчеты Просмотр Разрешения",
        "Chatbot-Berichte-Ansichtsberechtigung",
        "Autorisation d'affichage des rapports de chatbot",
        "Permiso de vista de informes de chatbot",
        "إذن عرض تقارير الدردشة",
        "Permesso di visualizzazione dei rapporti di chatbot"
    ),
    "chatbot.training.view": cretePermission(
        "chatbot.training.view",
        PERMISSION_GROUP_TYPES.CHATBOT,
        "Chatbot Bot Eğitimi Görüntüleme İzni",
        "Chatbot Bot Training View Permission",
        "Чатбот Обучение бота Просмотр Разрешения",
        "Chatbot Bot Training View Permission",
        "Autorisation d'affichage de la formation des robots de chatbot",
        "Permiso de vista de entrenamiento de bot de chatbot",
        "إذن عرض تدريب الروبوتات الدردشة",
        "Permesso di visualizzazione dell'addestramento del bot di chatbot"
    ),
    "chatbot.usersegments.create": cretePermission(
        "chatbot.usersegments.create",
        PERMISSION_GROUP_TYPES.CHATBOT,
        "Chatbot Kullanıcı Bölümleri Ekleme İzni",
        "Chatbot User Segments Create Permission",
        "Чатбот Пользовательские сегменты Создать Разрешение",
        "Chatbot-Benutzersegmente-Erstellungsberechtigung",
        "Autorisation de création de segments d'utilisateurs de chatbot",
        "Permiso de creación de segmentos de usuarios de chatbot",
        "إذن إنشاء أقسام مستخدمي الدردشة",
        "Permesso di creazione di segmenti utente di chatbot"
    ),
    "chatbot.usersegments.update": cretePermission(
        "chatbot.usersegments.update",
        PERMISSION_GROUP_TYPES.CHATBOT,
        "Chatbot Kullanıcı Bölümleri Güncelleme İzni",
        "Chatbot User Segments Update Permission",
        "Чатбот Пользовательские сегменты Обновить Разрешение",
        "Chatbot-Benutzersegmente-Update-Berechtigung",
        "Autorisation de mise à jour des segments d'utilisateurs de chatbot",
        "Permiso de actualización de segmentos de usuarios de chatbot",
        "إذن تحديث أقسام مستخدمي الدردشة",
        "Permesso di aggiornamento dei segmenti utente di chatbot"
    ),
    "chatbot.usersegments.delete": cretePermission(
        "chatbot.usersegments.delete",
        PERMISSION_GROUP_TYPES.CHATBOT,
        "Chatbot Kullanıcı Bölümleri Silme İzni",
        "Chatbot User Segments Delete Permission",
        "Чатбот Пользовательские сегменты Удалить Разрешение",
        "Chatbot-Benutzersegmente-Löschen-Berechtigung",
        "Autorisation de suppression des segments d'utilisateurs de chatbot",
        "Permiso de eliminación de segmentos de usuarios de chatbot",
        "إذن حذف أقسام مستخدمي الدردشة",
        "Permesso di eliminazione dei segmenti utente di chatbot"
    ),
    "integrations.view": cretePermission(
        "integrations.view",
        PERMISSION_GROUP_TYPES.INTEGRATIONS,
        "Entegrasyonlar Görüntüleme İzni",
        "Integrations View Permission",
        "Интеграции Просмотр Разрешения",
        "Integrationsansichtsberechtigung",
        "Autorisation d'affichage des intégrations",
        "Permiso de vista de integraciones",
        "إذن عرض التكاملات",
        "Permesso di visualizzazione delle integrazioni"
    ),
    "integrations.whatsapp.view": cretePermission(
        "integrations.whatsapp.view",
        PERMISSION_GROUP_TYPES.INTEGRATIONS,
        "Entegrasyonlar Whatsapp Görüntüleme İzni",
        "Integrations Whatsapp View Permission",
        "Интеграции Whatsapp Просмотр Разрешения",
        "Integrations-Whatsapp-Ansichtsberechtigung",
        "Autorisation d'affichage des intégrations Whatsapp",
        "Permiso de vista de integraciones de Whatsapp",
        "إذن عرض تكاملات Whatsapp",
        "Permesso di visualizzazione delle integrazioni Whatsapp"
    ),
    "integrations.instagram.view": cretePermission(
        "integrations.instagram.view",
        PERMISSION_GROUP_TYPES.INTEGRATIONS,
        "Entegrasyonlar Instagram Görüntüleme İzni",
        "Integrations Instagram View Permission",
        "Интеграции Instagram Просмотр Разрешения",
        "Integrations-Instagram-Ansichtsberechtigung",
        "Autorisation d'affichage des intégrations Instagram",
        "Permiso de vista de integraciones de Instagram",
        "إذن عرض تكاملات Instagram",
        "Permesso di visualizzazione delle integrazioni Instagram"
    ),
    "integrations.messenger.view": cretePermission(
        "integrations.messenger.view",
        PERMISSION_GROUP_TYPES.INTEGRATIONS,
        "Entegrasyonlar Messenger Görüntüleme İzni",
        "Integrations Messenger View Permission",
        "Интеграции Messenger Просмотр Разрешения",
        "Integrations-Messenger-Ansichtsberechtigung",
        "Autorisation d'affichage des intégrations Messenger",
        "Permiso de vista de integraciones de Messenger",
        "إذن عرض تكاملات Messenger",
        "Permesso di visualizzazione delle integrazioni di Messenger"
    ),
    "integrations.telegram.view": cretePermission(
        "integrations.telegram.view",
        PERMISSION_GROUP_TYPES.INTEGRATIONS,
        "Entegrasyonlar Telegram Görüntüleme İzni",
        "Integrations Telegram View Permission",
        "Интеграции Telegram Просмотр Разрешения",
        "Integrations-Telegram-Ansichtsberechtigung",
        "Autorisation d'affichage des intégrations Telegram",
        "Permiso de vista de integraciones de Telegram",
        "إذن عرض تكاملات Telegram",
        "Permesso di visualizzazione delle integrazioni Telegram"
    ),
    "integrations.create": cretePermission(
        "integrations.create",
        PERMISSION_GROUP_TYPES.INTEGRATIONS,
        "Entegrasyonlar Etkinleştirme İzni",
        "Integrations Enable Permission",
        "Интеграции Включить Разрешение",
        "Integrations Enable Permission",
        "Autorisation d'activation des intégrations",
        "Permiso de habilitación de integraciones",
        "إذن تمكين التكاملات",
        "Permesso di abilitazione delle integrazioni"
    ),
    "trigers.view": cretePermission(
        "trigers.view",
        PERMISSION_GROUP_TYPES.TRIGERS,
        "Tetikleyiciler Görüntüleme İzinleri",
        "Trigers View Permission",
        "Триггеры Просмотр Разрешения",
        "Triggers View Permission",
        "Autorisation d'affichage des déclencheurs",
        "Permiso de vista de desencadenantes",
        "إذن عرض المشغلات",
        "Permesso di visualizzazione dei trigger"
    ),
    "trigers.create": cretePermission(
        "trigers.create",
        PERMISSION_GROUP_TYPES.TRIGERS,
        "Tetikleyiciler Ekleme İzinleri",
        "Trigers Create Permission",
        "Триггеры Создать Разрешение",
        "Triggers Create Permission",
        "Autorisation de création de déclencheurs",
        "Permiso de creación de desencadenantes",
        "إذن إنشاء المشغلات",
        "Permesso di creazione di trigger"
    ),
    "trigers.update": cretePermission(
        "trigers.update",
        PERMISSION_GROUP_TYPES.TRIGERS,
        "Tetikleyiciler Güncelleme İzinleri",
        "Trigers Update Permission",
        "Триггеры Обновить Разрешение",
        "Triggers Update Permission",
        "Autorisation de mise à jour des déclencheurs",
        "Permiso de actualización de desencadenantes",
        "إذن تحديث المشغلات",
        "Permesso di aggiornamento dei trigger"
    ),
    "trigers.delete": cretePermission(
        "trigers.delete",
        PERMISSION_GROUP_TYPES.TRIGERS,
        "Tetikleyiciler Silme İzinleri",
        "Trigers Delete Permission",
        "Триггеры Удалить Разрешение",
        "Triggers Delete Permission",
        "Autorisation de suppression des déclencheurs",
        "Permiso de eliminación de desencadenantes",
        "إذن حذف المشغلات",
        "Permesso di eliminazione dei trigger"
    ),
    "billing.read": cretePermission(
        "billing.read",
        PERMISSION_GROUP_TYPES.BILLING,
        "Fatura ve Ödeme Yöntemi Görüntüleme İzni",
        "Billing and Payment Method View Permission",
        "Просмотр счетов и способов оплаты",
        "Rechnungs- und Zahlungsmethode anzeigen",
        "Autorisation d'affichage de la facturation et du mode de paiement",
        "Permiso de vista de facturación y método de pago",
        "إذن عرض الفواتير وطريقة الدفع",
        "Permesso di visualizzazione della fatturazione e del metodo di pagamento"
    ),
    "task.create": cretePermission(
        "task.create",
        PERMISSION_GROUP_TYPES.TASK,
        "Görev Ekleme",
        "Add Task",
        "Добавить задачу",
        "Aufgabe hinzufügen",
        "Ajouter une tâche",
        "Agregar tarea",
        "إضافة مهمة",
        "Aggiungi compito"
    ),
    "task.update": cretePermission(
        "task.update",
        PERMISSION_GROUP_TYPES.TASK,
        "Görev Güncelleme",
        "Update Task",
        "Редактировать задачу",
        "Aufgabe bearbeiten",
        "Modifier la tâche",
        "Editar tarea",
        "تعديل المهمة",
        "Modifica compito"
    ),
    "task.delete": cretePermission(
        "task.delete",
        PERMISSION_GROUP_TYPES.TASK,
        "Görev Silme",
        "Delete Task",
        "Удалить задачу",
        "Aufgabe löschen",
        "Supprimer la tâche",
        "Eliminar tarea",
        "حذف المهمة",
        "Elimina compito"
    ),
    "calendar.create": cretePermission(
        "calendar.create",
        PERMISSION_GROUP_TYPES.CALENDAR,
        "Etkinlik Ekleme",
        "Add Event",
        "Добавить событие",
        "Ereignis hinzufügen",
        "Ajouter un événement",
        "Agregar evento",
        "إضافة حدث",
        "Aggiungi evento"
    ),
    "calendar.read": cretePermission(
        "calendar.read",
        PERMISSION_GROUP_TYPES.CALENDAR,
        "Etkinlik Görüntüleme",
        "View Event",
        "Просмотр события",
        "Ereignis anzeigen",
        "Voir l'événement",
        "Ver evento",
        "عرض الحدث",
        "Visualizza evento"
    ),
    "calendar.update": cretePermission(
        "calendar.update",
        PERMISSION_GROUP_TYPES.CALENDAR,
        "Etkinlik Güncelleme",
        "Update Event",
        "Обновить событие",
        "Ereignis aktualisieren",
        "Mettre à jour l'événement",
        "Actualizar evento",
        "تحديث الحدث",
        "Aggiorna evento"
    ),
    "calendar.delete": cretePermission(
        "calendar.delete",
        PERMISSION_GROUP_TYPES.CALENDAR,
        "Etkinlik Silme",
        "Delete Event",
        "Удалить событи",
        "Ereignis löschen",
        "Supprimer l'événement",
        "Eliminar evento",
        "حذف الحدث",
        "Elimina evento"
    ),
    "mail.create": cretePermission(
        "mail.create",
        PERMISSION_GROUP_TYPES.MAIL,
        "Mail Oluşturma İzni",
        "Create Mail",
        "Создать почту",
        "Mail erstellen",
        "Créer un mail",
        "Crear correo",
        "إنشاء بريد",
        "Crea mail"
    ),
    "mail.read": cretePermission(
        "mail.read",
        PERMISSION_GROUP_TYPES.MAIL,
        "Mail Görüntüleme İzni",
        "View Mail",
        "Просмотр почты",
        "Mail anzeigen",
        "Afficher le courrier",
        "Ver correo",
        "عرض البريد",
        "Visualizza mail"
    ),
    "mail.update": cretePermission(
        "mail.update",
        PERMISSION_GROUP_TYPES.MAIL,
        "Mail Güncelleme İzni",
        "Update Mail",
        "Обновить почту",
        "Mail aktualisieren",
        "Mettre à jour le courrier",
        "Actualizar correo",
        "تحديث البريد",
        "Aggiorna mail"
    ),
    "mail.delete": cretePermission(
        "mail.delete",
        PERMISSION_GROUP_TYPES.MAIL,
        "Mail Silme İzni",
        "Delete Mail",
        "Удалить почту",
        "Mail löschen",
        "Supprimer le courrier",
        "Eliminar correo",
        "حذف البريد",
        "Elimina mail"
    ),
    "tags.create": cretePermission(
        "tags.create",
        PERMISSION_GROUP_TYPES.TAGS,
        "Etiket Oluşturma İzni",
        "Create Tag",
        "Создать тег",
        "Tag erstellen",
        "Créer une balise",
        "Crear etiqueta",
        "إنشاء علامة",
        "Crea tag"
    ),

    "tags.update": cretePermission(
        "tags.update",
        PERMISSION_GROUP_TYPES.TAGS,
        "Etiket Güncelleme İzni",
        "Update Tags",
        "Обновить тег",
        "Tag aktualisieren",
        "Mettre à jour l'étiquette",
        "Actualizar etiqueta",
        "تحديث العلامة",
        "Aggiorna tag"
    ),
    "tags.delete": cretePermission(
        "tags.delete",
        PERMISSION_GROUP_TYPES.TAGS,
        "Etiket Silme İzni",
        "Delete Tags",
        "Удалить тег",
        "Tag löschen",
        "Supprimer l'étiquette",
        "Eliminar etiqueta",
        "حذف العلامة",
        "Elimina tag"
    ),
};
